import { render, staticRenderFns } from "./ForumSection.vue?vue&type=template&id=2bf5db4c&scoped=true&"
import script from "./ForumSection.vue?vue&type=script&lang=js&"
export * from "./ForumSection.vue?vue&type=script&lang=js&"
import style0 from "./ForumSection.vue?vue&type=style&index=0&id=2bf5db4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5db4c",
  null
  
)

export default component.exports